const scout_routes = {
  path: '/scout',
  name: 'Scout',
  component: () => import("@/components/LayOut/Guest"),
  meta: { requiresAuth: false },
  children: [
    { // 首页
      path: 'index',
      component: () => import('@/views/scout/index'),
      meta: { requiresAuth: false },
    },
    { // 报告列表
      path: 'list',
      component: () => import('@/views/scout/list'),
      meta: { requiresAuth: false },
    },
    { // 报告列表 - 报告详情信息
      path: 'listDetails',
      component: () => import('@/views/scout/listDetails'),
      meta: { requiresAuth: false },
    },
    { // 比赛信息
      path: 'complete',
      component: () => import('@/views/scout/complete'),
      meta: { requiresAuth: false },
    },
    { // 球探信息
      path: 'scout_info',
      component: () => import('@/views/scout/scoutInfo'),
      meta: { requiresAuth: false },
    },
    { // 球员信息
      path: 'player_info',
      component: () => import('@/views/scout/playerInfo'),
      meta: { requiresAuth: false },
    },
    { // 五环评分
      path: 'five_rings',
      component: () => import('@/views/scout/fiveRings'),
      meta: { requiresAuth: false },
    },
    { // 主观评价
      path: 'subjective',
      component: () => import('@/views/scout/subjective'),
      meta: { requiresAuth: false },
    },
  ]
}


export default scout_routes